export default __webpack_public_path__ + "static/super-rare-4c0b57173fd70b5932682751a5fcd1c0.png";